import moment from 'moment';

import DTO from './DTO';
import IndividualEntrepreneurDTO from './IndividualEntrepreneurDTO';
import JuridicalDTO from './JuridicalDTO';
import InsurerDTO from './InsurerDTO';
import {
  required,
} from '../utils/validation';
import { USER_TYPE } from '../configs';

class CarrierDTO extends DTO {
  constructor(params, isValidInit) {
    const ipAttr = new IndividualEntrepreneurDTO().getAttributes();
    const legalAttr = new JuridicalDTO().getAttributes();
    const insurerAttr = new InsurerDTO().getAttributes();
    const attributes = [
      {
        name: 'view_mode',
        type: String,
        validators: {},
        labelKey: 'view_mode',
      },
      {
        name: 'id',
        type: String,
        validators: [],
        labelKey: 'id',
      },
      {
        name: 'legal_entity_type',
        type: Number,
        validators: [],
        labelKey: 'legal_entity_type',
      },
      ...ipAttr,
      ...legalAttr,
      ...insurerAttr,
      {
        name: 'number',
        type: String,
        validators: [],
        labelKey: 'registry.number',
      },
      {
        name: 'effective_date',
        type: moment,
        validators: [],
        labelKey: 'effective_date',
      },
      {
        name: 'expiration_date',
        type: moment,
        validators: [],
        labelKey: 'expiration_date',
      },
      {
        name: 'permission_grant_period',
        type: moment,
        validators: [],
        labelKey: 'permission_grant_period',
      },
      {
        name: 'status',
        type: String,
        validators: [],
        labelKey: 'status',
      },
      {
        name: 'created_at',
        type: moment,
        validators: [],
        labelKey: 'created_at',
      },
      {
        name: 'driver_license_files',
        type: String,
        validators: [required],
        labelKey: 'media.driver_license_files',
      },
      {
        name: 'driver_license_series',
        type: String,
        validators: params?.legal_entity_type === USER_TYPE.PRIVATE_PERSON ? [required] : [],
        labelKey: 'driver_license_series',
      },
      {
        name: 'driver_license_number',
        type: String,
        validators: params?.legal_entity_type === USER_TYPE.PRIVATE_PERSON ? [required] : [],
        labelKey: 'driver_license_number',
      },
      {
        name: 'driver_license_issue_date',
        type: String,
        validators: params?.legal_entity_type === USER_TYPE.PRIVATE_PERSON ? [required] : [],
        labelKey: 'driver_license_issue_date',
      },
      {
        name: 'driver_license_expiration_date',
        type: String,
        validators: params?.legal_entity_type === USER_TYPE.PRIVATE_PERSON ? [required] : [],
        labelKey: 'driver_license_expiration_date',
      },
      {
        name: 'medical_examination_address',
        type: String,
        validators: [],
        labelKey: 'medical_examination_address',
      },
      {
        name: 'commercial_name',
        type: String,
        validators: [],
        labelKey: 'commercial_name',
      },
      {
        name: 'logo_files',
        type: String,
        validators: [],
        labelKey: 'logo_files',
      },
      {
        name: 'carriage_file',
        type: String,
        validators: [required],
        labelKey: 'carriage_file',
      },
      {
        name: 'insurer',
        type: String,
        validators: [],
        labelKey: 'insurer',
      },
      {
        name: 'insurance_contract_number',
        type: String,
        validators: [],
        labelKey: 'insurance_contract_number',
      },
      {
        name: 'insurance_contract_effective_date',
        type: String,
        validators: [],
        labelKey: 'insurance_contract_effective_date',
      },
      {
        name: 'insurance_contract_expiration_date',
        type: String,
        validators: [],
        labelKey: 'insurance_contract_expiration_date',
      },
      {
        name: 'carriage_contract_number',
        type: String,
        validators: params?.legal_entity_type === USER_TYPE.PRIVATE_PERSON ? [required] : [],
        labelKey: 'carriage_contract_number',
      },
      {
        name: 'carriage_contract_effective_date',
        type: String,
        validators: params?.legal_entity_type === USER_TYPE.PRIVATE_PERSON ? [required] : [],
        labelKey: 'carriage_contract_effective_date',
      },
      {
        name: 'carriage_contract_expiration_date',
        type: String,
        validators: params?.legal_entity_type === USER_TYPE.PRIVATE_PERSON ? [required] : [],
        labelKey: 'carriage_contract_expiration_date',
      },
      {
        name: 'has_employees',
        type: Boolean,
        validators: [],
        labelKey: 'has_employees',
      },
      {
        name: 'medical_examination_address',
        type: String,
        validators: [],
        labelKey: 'medical_examination_address',
      },
      {
        name: 'criminal_record_certificate_info_doc',
        type: String,
        validators: [required],
        labelKey: 'media.criminal_record_certificate_info_doc',
        couldBeNull: true,
      },
      {
        name: 'criminal_record_note',
        type: String,
        validators: [],
        labelKey: 'criminal_record_note',
      },
      {
        name: 'decision',
        type: String,
        validators: [],
        labelKey: 'decision',
      },
      {
        name: 'decision_date',
        type: String,
        validators: [],
        labelKey: 'decision_date',
      },
      {
        name: 'order_service_ogrn',
        type: String,
        validators: [],
        labelKey: 'order_service_ogrn',
      },
      {
        name: 'order_service_id',
        type: String,
        validators: [],
        labelKey: 'order_service_id',
      },
      {
        name: 'order_service_contract_files',
        type: String,
        validators: [required],
        labelKey: 'media.order_service_contract_files',
      },
      {
        name: 'order_service_contract_number',
        type: String,
        validators: params?.legal_entity_type === USER_TYPE.PRIVATE_PERSON ? [required] : [],
        labelKey: 'order_service_contract_number',
      },
      {
        name: 'contract_number',
        type: String,
        validators: [],
        labelKey: 'order_service_contract_number',
      },
      {
        name: 'order_service_contract_effective_date',
        type: String,
        validators: params?.legal_entity_type === USER_TYPE.PRIVATE_PERSON ? [required] : [],
        labelKey: 'order_service_contract_effective_date',
      },
      {
        name: 'contract_effective_date',
        type: String,
        validators: [],
        labelKey: 'order_service_contract_effective_date',
      },
      {
        name: 'order_service_contract_expiration_date',
        type: String,
        validators: params?.legal_entity_type === USER_TYPE.PRIVATE_PERSON ? [required] : [],
        labelKey: 'order_service_contract_expiration_date',
      },
      {
        name: 'contract_expiration_date',
        type: String,
        validators: [],
        labelKey: 'order_service_contract_expiration_date',
      },
      {
        name: 'vehicle_ids',
        type: String,
        validators: [],
        labelKey: 'vehicle_ids',
      },
      {
        name: 'vehicle_numbers_attach',
        type: String,
        validators: [],
        labelKey: 'vehicle_numbers_attach',
      },
      {
        name: 'vehicle_numbers_detach',
        type: String,
        validators: [],
        labelKey: 'vehicle_numbers_detach',
      },
      {
        name: 'order_service_numbers',
        type: String,
        validators: [],
        labelKey: 'order_service_numbers',
      },
      {
        name: 'order_service_numbers_detach',
        type: String,
        validators: [],
        labelKey: 'order_service_numbers_detach',
      },
      // Дополнил исходя из названий полей в журнале иных сведений
      {
        name: 'carrier_full_name',
        type: String,
        validators: [],
        labelKey: 'full_name_legal',
      },
      {
        name: 'carrier_external_id',
        type: String,
        validators: [],
        labelKey: 'carrier.external_id',
      },
      {
        name: 'carrier_type',
        type: Number,
        validators: [],
        labelKey: 'legal_entity_type',
      },
      {
        name: 'carrier_legal_entity_form',
        type: String,
        validators: [],
        labelKey: 'legal_entity_form',
      },
      {
        name: 'carrier_short_name',
        type: String,
        validators: [],
        labelKey: 'short_name_legal',
      },
      {
        name: 'carrier_address',
        type: String,
        validators: [],
        labelKey: 'address',
      },
      {
        name: 'carrier_ur_address',
        type: String,
        validators: [],
        labelKey: 'legal_address',
      },
      {
        name: 'carrier_inn',
        type: String,
        validators: [],
        labelKey: 'inn',
      },
      {
        name: 'carrier_ogrn',
        type: String,
        validators: [],
        labelKey: 'ogrn',
      },
      {
        name: 'carrier_supervisor_last_name',
        type: String,
        validators: [],
        labelKey: 'Фамилия руководителя',
      },
      {
        name: 'carrier_supervisor_first_name',
        type: String,
        validators: [],
        labelKey: 'Имя руководителя',
      },
      {
        name: 'carrier_supervisor_middle_name',
        type: String,
        validators: [],
        labelKey: 'Отчество руководителя',
      },
      {
        name: 'carrier_phone',
        type: String,
        validators: [],
        labelKey: 'phone',
      },
      {
        name: 'carrier_email',
        type: String,
        validators: [],
        labelKey: 'pd.email',
      },
      {
        name: 'carrier_last_name',
        type: String,
        validators: [],
        labelKey: 'last_name',
      },
      {
        name: 'carrier_first_name',
        type: String,
        validators: [],
        labelKey: 'first_name',
      },
      {
        name: 'carrier_middle_name',
        type: String,
        validators: [],
        labelKey: 'middle_name',
      },
      {
        name: 'carrier_birth_date',
        type: String,
        validators: [],
        labelKey: 'birth_date',
      },
      {
        name: 'carrier_birth_place',
        type: String,
        validators: [],
        labelKey: 'place_of_birth',
      },
      {
        name: 'carrier_gender',
        type: String,
        validators: [],
        labelKey: 'gender',
      },
      {
        name: 'carrier_citizenship',
        type: String,
        validators: [],
        labelKey: 'citizenship',
      },
      {
        name: 'carrier_snils',
        type: String,
        validators: [],
        labelKey: 'snils',
      },
      {
        name: 'carrier_reg_type',
        type: String,
        validators: [],
        labelKey: 'registration_type',
      },
      {
        name: 'carrier_identity_type',
        type: String,
        validators: [],
        labelKey: 'identity_type_short',
      },
      {
        name: 'carrier_identity_issue_date',
        type: String,
        validators: [],
        labelKey: 'identity_issue_date',
      },
      {
        name: 'carrier_identity_series',
        type: String,
        validators: [],
        labelKey: 'identity_series',
      },
      {
        name: 'carrier_identity_number',
        type: String,
        validators: [],
        labelKey: 'identity_number',
      },
      {
        name: 'carrier_identity_issuer_code',
        type: String,
        validators: [],
        labelKey: 'identity_issuer_code',
      },
      {
        name: 'carrier_criminal_record',
        type: String,
        validators: [],
        labelKey: 'criminal_record_certificate_info_doc',
      },
      {
        name: 'carrier_identity_issuer',
        type: String,
        validators: [],
        labelKey: 'identity_issuer',
      },
      {
        name: 'carrier_office_address',
        type: String,
        validators: [],
        labelKey: 'address',
      },
      {
        name: 'carriage_contract_name',
        type: String,
        validators: [],
        labelKey: 'carriage_contract_name',
      },
      {
        name: 'carriage_vehicle_number',
        type: String,
        validators: [],
        labelKey: 'vehicle.registry.number',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default CarrierDTO;
